import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fleet-list-page',
  templateUrl: './fleet-list-page.component.html',
  styleUrls: ['./fleet-list-page.component.css']
})
export class FleetListPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
